(function () {
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function updateBreadcrumbs() {
    const pageParam = getQueryParam("page");
    const targetDiv = document.getElementById("dynamic-breadcrumbs");
    if (!targetDiv) return;

    const steps = [
      { page: "addProductsPage1", label: "1) Pick Staples" },
      { page: "addProductsPage2", label: "2) Choose Mains" },
      { page: "addProductsPage3", label: "3) Add Premium Cuts" },
      { page: "addProductsPage4", label: "4) Add Extras" },
      { page: "reviewPage", label: "5) Review Your Box" }
    ];

    const breadcrumbHTML = `
      <nav class="wanted-breadcrumbs" aria-label="Progress">
        <ol>
          ${steps.map(step => `
            <li class="${pageParam === step.page ? "current-step" : ""}">
              <span>${step.label}</span>
            </li>
          `).join("")}
        </ol>
      </nav>
    `;

    targetDiv.innerHTML = breadcrumbHTML;
  }

  updateBreadcrumbs();

  let lastUrl = location.href;
  new MutationObserver(() => {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      updateBreadcrumbs();
    }
  }).observe(document, { subtree: true, childList: true });

  window.addEventListener("popstate", updateBreadcrumbs);
})();
